import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'language'
})
export class LanguagePipe implements PipeTransform {
  translocoService = inject(TranslocoService)
  transform(value: string | undefined | null): string {
    switch (value) {
      case 'de':
        return this.translocoService.translate('language.de');
      case 'fr':
        return this.translocoService.translate('language.fr');
      case 'en':
        return this.translocoService.translate('language.en');
      case 'it':
        return this.translocoService.translate('language.it');
      default:
        return this.translocoService.translate('label.unknown');
    }
  }
}
